export default __webpack_public_path__ + "0ccfa79790d510ac0badd53ff15c45f8.jpg";